import { render } from "./ActionButton.vue?vue&type=template&id=06c7c731&scoped=true"
import script from "./ActionButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ActionButton.vue?vue&type=script&setup=true&lang=js"

import "./ActionButton.vue?vue&type=style&index=0&id=06c7c731&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06c7c731"],['__file',"src/components/UI/buttons/ActionButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "06c7c731"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('06c7c731', __exports__)) {
    api.reload('06c7c731', __exports__)
  }
  
  module.hot.accept("./ActionButton.vue?vue&type=template&id=06c7c731&scoped=true", () => {
    api.rerender('06c7c731', render)
  })

}


export default __exports__